'use client';
import { destroySession, setSession } from '@/lib/features/session/sessionSlice';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const UserAuth = ({session}) => {
    const dispatch = useDispatch();
    const pathName = usePathname();

    useEffect(() => {
        if (session) {
            if (session?.isLoggedIn) {
                dispatch(setSession(session));
            } else {
                dispatch(destroySession());
            }
        }
    }, [pathName, session, dispatch]);

    return null;
};

export default UserAuth;
